import React, { useState } from 'react';
import { Phone, Mail, Send, Check } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
export function ContactPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className="bg-white" data-id="element-137">
      <div className="bg-brand-dark text-white py-16" data-id="element-138">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-139">
          <h1 className="text-4xl font-bold mb-4" data-id="element-140">Contact Us</h1>
          <p className="text-xl text-gray-300" data-id="element-141">
            Get in touch with our sales and support team.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-142">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-143">
          {/* Contact Info */}
          <div data-id="element-144">
            <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-145">
              We're Here To Help
            </h2>
            <p className="text-gray-600 mb-10 text-lg" data-id="element-146">
              Have questions about the ForceX system? Need a custom quote for
              your fleet? Our team of industry experts is ready to assist you.
            </p>

            <div className="space-y-8" data-id="element-147">
              <div className="flex items-start" data-id="element-148">
                <div className="bg-brand-yellow/10 p-3 rounded-full mr-4" data-id="element-149">
                  <Phone className="h-6 w-6 text-brand-yellow" data-id="element-150" />
                </div>
                <div data-id="element-151">
                  <h3 className="font-bold text-brand-dark text-lg" data-id="element-152">Phone</h3>
                  <p className="text-gray-600 mb-1" data-id="element-153">
                    Mon-Fri from 8am to 5pm EST
                  </p>
                  <a href="tel:8108185941" className="text-xl font-bold text-brand-yellow hover:text-yellow-600" data-id="element-154">
                    810-818-5941
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-155">
                <div className="bg-brand-yellow/10 p-3 rounded-full mr-4" data-id="element-156">
                  <Mail className="h-6 w-6 text-brand-yellow" data-id="element-157" />
                </div>
                <div data-id="element-158">
                  <h3 className="font-bold text-brand-dark text-lg" data-id="element-159">Email</h3>
                  <p className="text-gray-600 mb-1" data-id="element-160">
                    For sales and support inquiries
                  </p>
                  <a href="mailto:brandon@precisionprosprayers.com" className="text-xl font-bold text-brand-yellow hover:text-yellow-600" data-id="element-161">
                    brandon@precisionprosprayers.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-brand-light p-8 rounded-xl border border-gray-200 shadow-sm" data-id="element-162">
            <h2 className="text-2xl font-bold text-brand-dark mb-6" data-id="element-163">
              Send a Message
            </h2>

            {isSubmitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center" data-id="element-164">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-165">
                  <Check className="h-8 w-8 text-green-600" data-id="element-166" />
                </div>
                <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-167">
                  Message Sent!
                </h3>
                <p className="text-green-700 mb-6" data-id="element-168">
                  Thank you for contacting Precision Pro Sprayers. A member of
                  our team will get back to you shortly.
                </p>
                <Button onClick={() => setIsSubmitted(false)} variant="outline" data-id="element-169">
                  Send Another Message
                </Button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-170">
                <Input label="Name" placeholder="John Doe" required data-id="element-171" />

                <Input label="Email" type="email" placeholder="john@company.com" required data-id="element-172" />

                <Textarea label="Message" placeholder="Tell us about your needs..." required data-id="element-173" />

                <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} data-id="element-174">
                  <Send className="w-4 h-4 mr-2" data-id="element-175" />
                  Send Message
                </Button>
              </form>}
          </div>
        </div>
      </div>
    </div>;
}